import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";

import { setTokenGetter } from "@/lib/api-client";

export const ApiAuthSync = () => {
  const { getToken } = useAuth();

  useEffect(() => {
    setTokenGetter(getToken);
  }, [getToken]);

  return null;
};
